export default __webpack_public_path__ + "static/media/10.1af8e50a.jpg";